module.exports = __webpack_public_path__ + "img/upload.574440a4.svg";